<template>
  <wrap-container>
    <help-title title="Formas de pago" />

    <help-list-container>
      <help-list-item
        tituloLista="Si tu tarjeta está adherida al débito automático (por el pago total o mínimo):"
      >
        Se debitará el pago en la fecha de vencimiento. Recordá tener dinero en
        tu cuenta.
      </help-list-item>

      <help-list-item
        tituloLista="Si no estás adherido al débito automático podés pagar:"
      >
        A través de
        <a id="contactForm" href="https://www.bbva.com.ar">Banca Online</a> o
        BBVA Movil:
        <br />
        - Ingresá con tu DNI, Usuario y Clave Digital.<br />
        - Seleccioná <strong>"Tarjetas"</strong> y luego
        <strong>"Pagar la tarjeta"</strong>. <br />
        - Ingresá el importe que querés pagar.<br />
        - Elegí la cuenta para hacer el débito.
        <br /><br />

        A través de Go, la app de beneficios de BBVA:
        <br />
        - Ingresá a la sección <strong>"Mis Tarjetas"</strong>.<br />
        - Ingresá tu DNI, Usuario y Clave Digital.<br />
        - Seleccioná la tarjeta que querés pagar y luego
        <strong>"Pagar"</strong>.<br /><br />

        En efectivo:
        <br />
        - Realizando un depósito en nuestras terminales de autoservicio. Recordá
        que el pago por ventanilla en las sucursales no está habilitado.
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
